@if (!product().variantOptions) {
  @if (product().isNew | safeCheck) {
    <boels-product-new></boels-product-new>
  }
  @if (product().oneCall | safeCheck) {
    <boels-product-one-call></boels-product-one-call>
  }
  <boels-product-code
    [product]="product()"
    [displayDescription]="displayCodeDescription()"
  ></boels-product-code>
}
